// externals
import React from 'react';

// components
import { Typography } from '@interstate/components/Typography';

// consts/enums
import { CREATE_DEAL_IDENTIFIER } from './createDealConsts';

// styles
import { ReadOnlyField } from './CreateDealModal.style';

const EMPTY_VALUE = '—';

export type LabelledValueProps = {
    label: string;
    value: string;
    name: string;
    placeholder?: string;
};

export const LabelledValue: React.FC<LabelledValueProps> = ({ label, value, name, placeholder = EMPTY_VALUE }) => (
    <ReadOnlyField>
        <Typography variant="label-md" color="base.color.gray.600" tag="span">
            {label}
        </Typography>
        <Typography variant="body-md" tag="span" data-testid={`${CREATE_DEAL_IDENTIFIER}-${name}`}>
            {value || placeholder}
        </Typography>
    </ReadOnlyField>
);

export default LabelledValue;
